/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import {
  Header,
  Footer,
  Loading,
  SetCalendar,
  ShareButton,
  Snackbar,
} from '../../../../components/index'
import { useHistory } from 'react-router-dom'
import FI from 'react-flickity-component'
import { FiHeart } from 'react-icons/fi'
import { UploadsUrl } from '../../../../services/url'
import { WebApi } from '../../../../api/web'
import Moment from 'moment-jalaali'
import { FixNumbers } from '../../../../utilities/convertType'

const DetailLawer = ({ loading, lawyer, like, LikeDisLike, countLike, id }) => {
  const [indexDay, setIndexDay] = useState(null)
  const [loadingChild, setLoading] = useState(false)
  const router = useHistory()
  const [times, setTimes] = useState([])
  const [data, setData] = useState(null)
  const [selectTime, setSelectTime] = useState(null)
  const [timeDuration, setTimeDuration] = useState(0)
  const [startTime, setStartTime] = useState('00:00')
  const [endTime, setEndTime] = useState('00:00')
  const [consultingData, setConsultingData] = useState(null)
  const [lawyerCalendar, setLawyerCalendar] = useState(null)
  const [workday, setworkday] = useState([])
  const [holidayTime, setHolidayTime] = useState([])
  const [holidayDate, setHolidayDate] = useState([])

  useEffect(() => {
    CalendarLawyer()
  }, [])

  const CalendarLawyer = async () => {
    setLoading(true)
    let arr = []
    let arr2 = []
    await WebApi.calendarLawyer(id)
      .then((res) => {
        setLoading(false)
        setLawyerCalendar(res.data.data.workDays)
        res.data.data.workDays.businessDays.map((day) => {
          if (day.day == 6) {
            arr2.push(0)
          } else {
            arr2.push(day.day + 1)
          }
        })
        setworkday(arr2)
        res.data.data.workDays.holidayDays.map((day) => {
          if (!day.time) {
            arr.push(
              `${FixNumbers(Moment(day.date).format('jYYYY'))}/${FixNumbers(
                Moment(day.date).format('jMM')
              )}/${FixNumbers(Moment(day.date).format('jDD'))}`
            )
          }
        })
        setHolidayDate(arr)
      })
      .catch((err) => {
        setLoading(false)
      })
  }

  useEffect(() => {
    GetTimeDays()
  }, [indexDay])

  const GetTimeDays = () => {
    if (lawyerCalendar) {
      let flag = true
      lawyerCalendar.businessDays.map((data) => {
        if (data.day == indexDay) {
          flag = false
          setStartTime(data.from)
          setEndTime(data.to)
        }
      })
      if (flag) {
        setStartTime('00:00')
        setEndTime('00:00')
      }
    }
  }

  useEffect(() => {
    CalendarDuration()
  }, [])

  const CalendarDuration = async () => {
    await WebApi.calendarDuration()
      .then((res) => {
        setTimeDuration(res.data.data.calenderDuration.time)
      })
      .catch((err) => {})
  }

  useEffect(() => {
    setDuration()
  }, [startTime, endTime, indexDay])

  const setDuration = () => {
    let arrayTime = []
    let duration = time_convert(timeDuration)
    let durationHour = Number(duration.split(':')[0])
    let durationMinute = Number(duration.split(':')[1])
    let StartHour = Number(startTime.split(':')[0])
    let StartMinute = Number(startTime.split(':')[1])
    let EndHour = Number(endTime.split(':')[0])
    while (StartHour < EndHour) {
      arrayTime.push(`${StartHour}:${String(StartMinute).padStart(2, 0)}`)
      StartMinute += durationMinute
      if (StartMinute > 59) {
        StartHour += 1
        StartMinute = StartMinute - 2 * durationMinute
      }
      StartHour += durationHour
      if (StartHour > 24) {
        StartHour = StartHour - 24
      }
    }
    setTimes(arrayTime)
  }

  function time_convert(num) {
    var hours = Math.floor(num / 60)
    var minutes = num % 60
    return hours + ':' + minutes
  }

  useEffect(() => {
    SingleConsulting()
  }, [])

  const SingleConsulting = async () => {
    setLoading(true)
    await WebApi.singleConsulting(localStorage.getItem('consultingId'))
      .then((res) => {
        setConsultingData(res.data.data.consulting)
        if (res.data.data.consulting.reserveTime.date) {
          router.push('/profile/services')
        }
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false)
      })
  }

  const ConsultingSetTime = async () => {
    if (data && selectTime) {
      setLoading(true)
      await WebApi.consultingSetTime(consultingData._id, data, selectTime)
        .then((res) => {
          setLoading(false)
          Snackbar({
            title: 'موفق',
            message: 'رزرو شما با موفقیت ثبت شد',
            type: 'success',
          })
          router.push(`/profile-lawyer/${res.data.data.consultingSetTime._id}`)
        })
        .catch((err) => {
          setLoading(false)
        })
    } else {
      Snackbar({
        title: 'نا موفق',
        message: 'تاریخ و زمان خود را به دقت وارد کنید',
        type: 'danger',
      })
    }
  }
  useEffect(() => {
    let arr = []
    if (data && lawyerCalendar) {
      lawyerCalendar.holidayDays.map((day) => {
        if (
          `${FixNumbers(Moment(day.date).format('jYYYY'))}/${FixNumbers(
            Moment(day.date).format('jMM')
          )}/${FixNumbers(Moment(day.date).format('jDD'))}` ==
          `${FixNumbers(Moment(data).format('jYYYY'))}/${FixNumbers(
            Moment(data).format('jMM')
          )}/${FixNumbers(Moment(data).format('jDD'))}`
        ) {
          arr.push(day.time)
        }
      })
      lawyerCalendar.reservedTime.map((day) => {
        if (
          `${FixNumbers(Moment(day.date).format('jYYYY'))}/${FixNumbers(
            Moment(day.date).format('jMM')
          )}/${FixNumbers(Moment(day.date).format('jDD'))}` ==
          `${FixNumbers(Moment(data).format('jYYYY'))}/${FixNumbers(
            Moment(data).format('jMM')
          )}/${FixNumbers(Moment(data).format('jDD'))}`
        ) {
          arr.push(day.time)
        }
      })
    }
    setHolidayTime(arr)
  }, [data])

  const flickityOptions = {
    initialIndex: 2,
    prevNextButtons: false,
    pageDots: false,
    rightToLeft: true,
  }

  return (
    <>
      {loading && loadingChild && <Loading />}
      <Header title='جزئیات پروفایل وکیل' />
      {consultingData && lawyer && lawyerCalendar ? (
        <div className='container'>
          <div className='template-pages'>
            <div className='top-section-single'>
              <div className='click-top-section' onClick={() => LikeDisLike()}>
                {like ? (
                  <FiHeart size={25} fill={'#d81818'} color={'#d81818'} />
                ) : (
                  <FiHeart size={25} />
                )}
                <div className='count-Likes'>{countLike}</div>
              </div>
              <div className='avatar'>
                <img
                  className='box-shadow'
                  src={`${UploadsUrl}/${lawyer.avatar}`}
                  alt='user'
                />
              </div>
              <ShareButton url={window.location.href} />
            </div>
            <div className='about-lawer set-calendar'>
              <div>
                <h2>{`${lawyer.fname} ${lawyer.lname}`}</h2>
                <h5>{lawyer.title}</h5>
              </div>
            </div>
            <div className='layer-shadow'></div>
            <>
              <div>
                <SetCalendar
                  {...{
                    lawyerCalendar,
                    setIndexDay,
                    indexDay,
                    setData,
                    holidayDate,
                    workday,
                  }}
                />
                <div className='layer-shadow'></div>
              </div>
              <div className='choose-time-calendar'>
                {times.length > 0 ? (
                  <>
                    <div className='title'>
                      <h3>انتخاب زمان مشاوره</h3>
                    </div>
                    <div className={`select-button`}>
                      <FI
                        draggable={true}
                        reloadOnUpdate={false}
                        pageDots={false}
                        options={flickityOptions}
                      >
                        {times.map((time) => (
                          <span
                            className={
                              holidayTime.includes(time) ? 'disable' : ''
                            }
                          >
                            <button
                              disabled={holidayTime.includes(time)}
                              className={time == selectTime ? 'active' : ''}
                              onClick={() =>
                                setSelectTime(time == selectTime ? null : time)
                              }
                            >
                              {time}
                            </button>
                          </span>
                        ))}
                      </FI>
                    </div>
                  </>
                ) : (
                  <div className='title'>
                    <h3>بازه زمانی مشخص نشده است</h3>
                  </div>
                )}
                <div
                  className='btn-register box-shadow'
                  onClick={() => ConsultingSetTime()}
                >
                  ثبت رزرو
                </div>
              </div>
            </>
          </div>
        </div>
      ) : (
        <Loading />
      )}
      <Footer />
    </>
  )
}
export default DetailLawer
